// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._nd5l11ig{grid-area:1/2/2/3}._1wpz1h6o{align-self:center}", ""]);
// Exports
module.exports = exports;
